module.exports = __webpack_public_path__ + "img/fernando-viviani.812d70cd.jpg";